import { getStatistics } from "utils/interface";
import update from 'immutability-helper'

export const dashboard = {
  state: {
    myOrder: {},
    mySales: {},
    shopOrder: {},
    shopSales: {}
  },
  effects: {
    async getMyOrderStatistics() {
      const data: any = await getStatistics({ type: "myOrder" })
      this.setMyOrder(data.data)
    },
    async getMySaleStatistics() {
      const data: any = await getStatistics({ type: "mySale" })
      this.setMySales(data.data)
    },
    async getShopSaleStatistics() {
      const data: any = await getStatistics({ type: "sale" })
      this.setShopSales(data.data)
    },
    async getShopOrderStatistics() {
      const data: any = await getStatistics({ type: "order" })
      this.setShopOrder(data.data)
    },
  },
  reducers: {
    setMyOrder(state, data) {
      return update(state, {
        myOrder: { $set: data }
      })
    },
    setMySales(state, data) {
      return update(state, {
        mySales: { $set: data }
      })
    },
    setShopOrder(state, data) {
      return update(state, {
        shopOrder: { $set: data }
      })
    },
    setShopSales(state, data) {
      return update(state, {
        shopSales: { $set: data }
      })
    },
  }
};
